if (!customElements.get('added-notification')) {
  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      this.dismissOthers();
      this.setProductTitle(this.dataset.productTitle);
      this.setProductImage(this.dataset.productImage);
      this.placeAtCart();
      this.display();
    }

    disconnectedCallback() {
      clearTimeout(this.delayedDismissTimeout);
    }

    dismissOthers() {
      document.querySelectorAll('.added-notification').forEach((notification) => {
        if (notification !== this) {
          notification.dismiss();
        }
      });
    }

    setProductTitle(productTitle) {
      this.querySelector('.added-notification__message-title').innerText = productTitle;
    }

    /* product thumbnail (quick-add from cards passes the cart line image); hidden when unknown */
    setProductImage(src) {
      const media = this.querySelector('.added-notification__media');
      const img = this.querySelector('.added-notification__img');
      if (!media || !img || !src) return;
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      media.hidden = false;
    }

    /* Tattup (26.10.2026): sit just below the bars that are stuck to the top of the screen right now (announcement bar,
       header, condensed search/cart bar), so the cart icon and its count are never covered. */
    placeBelowTopBars() {
      let bottom = 0;
      document.querySelectorAll('page-header, .announcement-bar, .mobile-sticky-bar, #shopify-section-announcement-bar, .shopify-section-group-header-group').forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.height > 0 && r.bottom > 0 && r.top <= bottom + 2 && r.bottom < window.innerHeight * 0.45) bottom = Math.max(bottom, r.bottom);
      });
      this.style.top = Math.round(bottom + 8) + 'px';
    }

    /* Tattup (26.10.2026, owner: «bisschen kleiner direkt über dem Warenkorb-Symbol»): a small card right under the cart
       icon that is visible now, with a little tip pointing at it; the icon gives a short bump. No cart icon in view (rare)
       -> below the top bars. */
    placeAtCart() {
      const icons = Array.prototype.filter.call(document.querySelectorAll('a.cart-link'), (el) => {
        const r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0 && r.top >= -1 && r.bottom <= window.innerHeight * 0.45 && getComputedStyle(el).visibility !== 'hidden';
      });
      if (!icons.length) { this.placeBelowTopBars(); return; }
      const r = icons[0].getBoundingClientRect();
      const right = Math.max(8, Math.round(window.innerWidth - r.right - 2));
      this.style.top = Math.round(r.bottom + 10) + 'px';
      this.style.right = right + 'px';
      this.style.left = 'auto';
      const caret = Math.round(window.innerWidth - right - (r.left + r.width / 2) - 6);
      this.style.setProperty('--tt-caret-right', Math.max(10, caret) + 'px');
      icons.forEach((el) => {
        el.classList.remove('tt-cart-bump');
        void el.offsetWidth;
        el.classList.add('tt-cart-bump');
        setTimeout(() => el.classList.remove('tt-cart-bump'), 700);
      });
    }

    display() {
      // reveal
      setTimeout(() => this.classList.remove('added-notification--hidden'), 10);

      // dismiss after a short period of time – Tattup 26.10.2026: 2.5 s is enough to read «✓ Eingepackt» + the name
      // (owner: «kürzest mögliche Dauer»); kept open while the mouse is on it
      this.delayedDismissTimeout = setTimeout(this.dismiss.bind(this), 2500);
      this.addEventListener('mouseenter', () => clearTimeout(this.delayedDismissTimeout));
      this.addEventListener('mouseleave', () => { clearTimeout(this.delayedDismissTimeout); this.delayedDismissTimeout = setTimeout(this.dismiss.bind(this), 1200); });

      // close button
      this.querySelector('.added-notification__close').addEventListener('click', this.dismiss.bind(this));

      // P1-6: make the WHOLE notification tappable (open the cart), not just
      // the small "cart" link — the narrow target caused mis-taps on mobile.
      this.addEventListener('click', (evt) => {
        if (evt.target.closest('.added-notification__close')) return;
        evt.preventDefault();
        if (theme.settings.cartType === 'drawer' && document.querySelector('.js-cart-drawer')) {
          document.querySelector('.js-cart-drawer').open();
          this.dismiss();
        } else if (theme.routes && theme.routes.cart) {
          window.location.href = theme.routes.cart;
        }
      });
    }

    dismiss(evt) {
      if (evt) { evt.preventDefault(); }
      this.classList.add('added-notification--dismissed');
      setTimeout(this.remove.bind(this), 400);
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}
